@if (!dismissed) {
    <div
        class="snackbar"
        animate.enter="snackbar-enter"
        animate.leave="snackbar-leave"
        (mouseenter)="pause()"
        (mouseleave)="resume()"
        (click)="dismiss()"
        (animationend)="onAnimationEnd($event)"
    >
        @if (icon) {
            <stby-icon size="24" [icon]="icon" [fill]="iconFill || 'currentColor'" />
        }
        <div class="snackbar-text">
            <div [class.bold]="content">{{ title }}</div>
            @if (content) {
                <div>{{ content }}</div>
            }
        </div>
    </div>
}
